// Brand assets (fantasy RPG academy aesthetic), self-hosted from public/media
export const CREST_EMBLEM = "/logo.png";

export const CLASS_SIGILS = {
  sage: "/media/badges/sigil-sage.png",
  retriever: "/media/badges/sigil-retriever.png",
  architect: "/media/badges/sigil-architect.png",
  alchemist: "/media/badges/sigil-alchemist.png",
};

export const RANK_BADGES = {
  0: "/media/badges/rank-0.png",
  1: "/media/badges/rank-1.png",
  2: "/media/badges/rank-2.png",
  3: "/media/badges/rank-3.png",
  4: "/media/badges/rank-4.png",
};

export const LOGO_MARK = "/logo.png";
export const JOURNEY_MAP = "/media/journey-map.png";
